import * as Entities from '@/shared/openapi-premios-client/api';
export default class EntityFactory {
  public static getDefaultCatalogo(): any {
    return {
      id: null,
      nombre: '',
    };
  }

  public static getDefaultCatalogoClave(): any {
    return {
      id: null,
      clave: null,
      nombre: '',
    };
  }

  public static getDefaultCatalogoClaveInstitucion(): any {
    return {
      //id: diez-mil para institución - manual e ingManInst para ingresoManualInstitucion
      id: 10000,
      clave: 'ingManInst',
      nombre: '',
    };
  }

  public static getDomicilioComp(): any {
    return {
      domicilio: this.getDomicilio(),
    };
  }

  public static getDefaultPublicaPrivada(): any {
    return {
      id: null,
      nombre: '',
      id2: null,
      nombre2: '',
    };
  }

  public static getUsuariosInternos(): any {
    return {
      id: null,
      numeroCvu: '',
      nombre: '',
      primerApellido: '',
      segundoApellido: '',
      rolesInternos: [],
      estatus: true,
    };
  }

  public static getUsuariosExternos(): any {
    return {
      id: null,
      numeroCvu: '',
      nombre: '',
      primerApellido: '',
      segundoApellido: '',
      convocatoria: '',
      rolesExternos: '',
      estatus: true,
      miembroComisionPlenaria: false,
    };
  }

  public static getUsuario(): Entities.Usuario {
    return {
      id: null,
      cvu: '',
      nombre: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      curp: '',
      activated: true,
    };
  }

  public static getRolesUsuarioValidos(): any {
    return [
      'CONSULTA',
      'COORDINADOR',
      'EVALUADOR_INDIVIDUAL',
      'PRESIDENTE_COMISION',
      'ROLE_ADMIN_PREMIOS',
      'ROLE_EXTERNAL_USER',
      'VALIDADOR_DOCUMENTAL',
    ];
  }

  public static getNacionalExtranjeroOptions(): any {
    return [
      { value: 'NACIONAL', text: 'en México' },
      { value: 'EXTRANJERA', text: 'en el extranjero' },
    ];
  }

  public static getBooleanOptions(): any {
    return [
      { value: { id: 'false', nombre: 'No' }, text: 'No' },
      { value: { id: 'true', nombre: 'Si' }, text: 'Sí' },
    ];
  }

  public static getRawBooleanOptions(): any {
    return [
      { value: false, text: 'No' },
      { value: true, text: 'Si' },
    ];
  }

  public static getEsExtranjeroBooleanOptions(): any {
    return [
      { value: false, text: 'Mexicana(o)' },
      { value: true, text: 'Extranjera(o)' },
    ];
  }

  public static getTipoDomicilioOptions(): any {
    return [
      { value: 'URBANO', text: 'Urbano' },
      { value: 'RURAL', text: 'Rural' },
    ];
  }

  public static getTipoInstitucionOptions(): any {
    return [
      { value: { id: '1', nombre: 'Pública' }, text: 'Pública' },
      { value: { id: '2', nombre: 'Privada' }, text: 'Privada' },
      { value: { id: '3', nombre: 'Ambas' }, text: 'Ambas' },
    ];
  }

  public static getTipoEntidadOptions(): any {
    return [
      { value: 'CONACYT', text: 'SECIHTI' },
      { value: 'OTROS', text: 'Otros' },
    ];
  }

  public static getTipoPublicaPrivada(): any {
    return [
      { value: { id: '01', nombre: 'Pública', id2: '01', nombre2: 'Federal' }, text: 'Pública - Federal' },
      { value: { id: '01', nombre: 'Pública', id2: '02', nombre2: 'Estatal' }, text: 'Pública - Estatal' },
      { value: { id: '01', nombre: 'Pública', id2: '03', nombre2: 'Municipal' }, text: 'Pública - Municipal' },
      { value: { id: '02', nombre: 'Privada', id2: '', nombre2: '' }, text: 'Privada' },
    ];
  }

  public static getNombrePlataforma(): any {
    return [
      { value: { id: '1', nombre: 'MIIC' }, text: 'MIIC' },
      { value: { id: '2', nombre: 'SALSA' }, text: 'SALSA' },
      { value: { id: '2', nombre: 'PS' }, text: 'PEOPLESOFT' },
    ];
  }

  public static getNombreSubsistema(): any {
    return [
      { value: { id: '1', nombre: 'FOMIX' }, text: 'FONDOS MIXTOS (FOMIX)' },
      { value: { id: '2', nombre: 'FOSEC' }, text: 'FONDOS SECTORIALES (FOSEC)' },
      {
        value: { id: '2', nombre: 'FORDECYT' },
        text: 'FONDO INSTITUCIONAL DE FOMENTO REGIONAL PARA EL DESARROLLO CIENTÍFICO, TECNOLÓGICO Y DE INNOVACIÓN (FORDECYT)',
      },
    ];
  }

  public static getCatRolesExternos(): any {
    return [
      { value: { id: '4', nombre: 'Evaluador Individual' }, text: 'Evaluador Individual' },
      { value: { id: '5', nombre: 'Presidente Comisión' }, text: 'Presidente Comisión' },
    ];
  }

  public static getCatRolesInternos(): any {
    return [
      { value: { id: '1', nombre: 'Coordinador' }, text: 'Coordinador' },
      { value: { id: '2', nombre: 'Validador Documental' }, text: 'Validador Documental' },
      { value: { id: '3', nombre: 'Consulta' }, text: 'Consulta' },
    ];
  }

  public static getDemo(): any {
    return {
      nombre: 'defaul',
      tipoPerfil: this.getDefaultCatalogo(),
      preguntas: [],
    };
  }

  public static getCatalogoExtendido(): any {
    return {
      id: null,
      nombre: null,
      clave: null,
      version: null,
    };
  }

  public static getAreaModelo(): any {
    return {
      id: null,
      nombre: null,
      clave: null,
    };
  }

  public static getAreaConocimiento(): any {
    return {
      area: null,
      campo: null,
      disciplina: null,
      subdisciplina: null,
    };
  }

  public static getDomicilio(): any {
    return {
      tipoUbicacion: 'NACIONAL',
      codigoPostal: null,
      estado: null,
      municipio: null,
      localidad: null,
      asentamiento: null,
      tipoAsentamiento: null,
      compartir: false,
      tipoDomicilio: 'URBANO',
      tipoVialidadRural: null,
      tipoVialidadUrbano: null,
      nombreVialidad: null,
      exteriorAnterior: null,
      exteriorNumerico: null,
      exteriorAlfanumerico: null,
      interiorNumerico: null,
      interiorAlfanumerico: null,
      requiereDetalle: false,
      tipoReferencia01: null,
      nombreReferencia01: null,
      tipoReferencia02: null,
      nombreReferencia02: null,
      tipoReferencia03: null,
      nombreReferencia03: null,
      descripcion: null,
      administracion: null,
      derechoTransito: null,
      codigo: null,
      origenTramo: null,
      destinoTramo: null,
      cadenamiento: null,
      margen: null,
      pais: null,
      cpExtranjero: null,
      estadoExtranjero: null,
      ciudadExtranjero: null,
      condadoExtranjero: null,
      calleExtranjero: null,
      numeroExtranjero: null,
    };
  }

  public static getInstitucionModel(): any {
    return {
      id: null,
      clave: null,
      nombre: null,
      tipo: null,
      pais: null,
      entidad: null,
      municipio: null,
      nivelUno: null,
      nivelDos: null,
    };
  }

  public static setInstitucion(): any {
    return {
      buscadorInstitucion: '',
      tipoInstitucion: {
        id: '01',
        nombre: 'Nacional',
      },
      publicaPrivada: this.getDefaultPublicaPrivada(),
      pais: this.getDefaultCatalogo(),
      entidad: this.getDefaultCatalogoClave(),
      municipio: this.getDefaultCatalogoClave(),
      institucion: this.getDefaultCatalogoClave(),
      institucionManual: this.getDefaultCatalogoClaveInstitucion(),
    };
  }

  public static getScian(): any {
    return {
      sector: null,
      subsector: null,
      rama: null,
      subrama: null,
      clase: null,
    };
  }

  public static getOcde(): any {
    return {
      sector: null,
      division: null,
      grupo: null,
      clase: null,
    };
  }

  public static getdatosGeneralesRepresentanteSede() {
    return {
      curp: null,
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      rfc: null,
      paisNacimiento: null,
      estado: null,
      nacionalidad: null,
      estadoConyugal: null,
      cvu: null,
    };
  }

  public static getBandejaPostulador(): any {
    return {
      noRegistro: null,
      razonSocial: null,
    };
  }

  public static getComentario(): any {
    return {
      comentario: null,
    };
  }

  public static getCambioDatos(): any {
    return {
      rfc: null,
      razonSocial: null,
      comentario: null,
    };
  }

  private static obtenerValorDecodificado(clave: string): string | null {
    const valorCodificado = localStorage.getItem(clave);
    if (valorCodificado === null) {
      return null;
    }
    try {
      return window.atob(valorCodificado);
    } catch (error) {
      return null;
    }
  }

  // Método para decodificar y convertir a booleano
  private static obtenerValorDecodificadoBooleano(clave: string): boolean {
    const valorCodificado = localStorage.getItem(clave);
    if (valorCodificado === null) {
      return false; // Valor predeterminado si no existe
    }
    try {
      const valorDecodificado = window.atob(valorCodificado);
      return valorDecodificado === 'true'; // Convierte "true" en `true`, "false" en `false`
    } catch (error) {
      return false;
    }
  }

  public static obtenerCvuUsuario() {
    return this.obtenerValorDecodificado('cvuUsuario');
  }

  public static obtenerIdSolicitud() {
    return this.obtenerValorDecodificado('idSolicitud');
  }

  public static obtenerRecargaIntentada() {
    return this.obtenerValorDecodificadoBooleano('recargaIntentada');
  }

  public static obtenerPuedeEnviar() {
    return this.obtenerValorDecodificadoBooleano('puedeEnviar');
  }

  public static guardarRecargaIntentada(valor: boolean): void {
    localStorage.setItem('recargaIntentada', window.btoa(String(valor)));
  }

  public static guardarPuedeEnviar(valor: boolean): void {
    localStorage.setItem('puedeEnviar', window.btoa(String(valor)));
  }

  public static getComentarioTemporal(): any {
    return {
      comentario: null,
    };
  }

  public static getFile(): any {
    return {
      contentType: null,
      content: null,
      nombre: null,
      size: null,
      uri: null,
    };
  }

  public static getTipoBusqueda(): any {
    return [
      { value: 'cvu', text: 'CVU' },
      { value: 'curp', text: 'CURP' },
    ];
  }

  public static getPostuladorBusqueda(): any {
    return {
      cvu: null,
      curp: null,
    };
  }

  public static getPostuladorBusquedaAdmin(): any {
    return {
      cvu: null,
      curp: null,
      nivelSnii: null,
    };
  }

  public static getSolicitud(): Entities.Solicitud {
    return {
      id: null,
      fechaSolicitud: null,
      folio: null,
      proponente: this.getProponente(),
      datosSolicitud: null, // dejar en null para poder insertar
      documentos: null,
      persona: this.getPersona(),
      estatusSolicitudes: null,
      activated: null,
    };
  }

  public static getDatosSolicitud(): Entities.DatosSolicitud {
    return {
      id: null,
      solicitudId: null,
      semblanza: null,
      evidenciaImpacto: null,
      institucion: null,
      activated: null,
    };
  }

  public static getDatosSolicitud2026(): Entities.DatosSolicitud2026 {
    return {
      id: null,
      solicitudId: null,
      semblanza: null,
      lineasInvestigacion: null,
      trayectoriaEvolucion: null,
      cartaMotivos: null,
      contribucionesClave: null,
      reconocimientos: null,
      produccionCientifica: null,
      hIndex: null,
      proyectosFinanciados: null,
      innovacionImpacto: null,
      fortalecimientoInstitucional: null,
      tesisDirigidas: null,
      formacionRecursos: null,
      problemaSalud: null,
      institucion: null,
      activated: null,
    };
  }

  public static getDocumento(): Entities.Documento {
    return {
      id: null,
      solicitudId: null,
      nombre: null,
      url: null,
      tipoDocumento: null,
      tipoArchivo: null,
      activated: null,
    };
  }

  public static getAsignacionEvaluadorResumen(): Entities.AsignacionEvaluadorResumen {
    return {
      convocatoriaId: null,
      cvu: null,
      usuarioId: null,
      nombreUsuario: null,
      rol: null,
      totalSolicitudes: null,
      totalEvaluadas: null,
      totalPendientes: null,
      totalDesasignadaRechazada: null,
    };
  }

  public static getPersona(): Entities.Persona {
    return {
      id: null,
      solicitudId: null,
      curp: null,
      cvu: null,
      nivelSnii: null,
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      fechaNacimiento: null,
      generoId: null,
      generoNombre: null,
      nacionalidadId: null,
      nacionalidadNombre: null,
      paisNacimientoId: null,
      paisNacimientoNombre: null,
      activated: null,
      correo: null,
    };
  }

  public static getProponente(): Entities.Proponente {
    return {
      id: null,
      solicitudId: null,
      cvu: null,
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      activated: null,
    };
  }

  public static getFiltros(): any {
    return {
      nivelSnii: null,
      cvu: null,
      nombre: null,
    };
  }

  public static getModalDesfinalizar(): any {
    return {
      motivoDesfinalizacion: null,
    };
  }

  public static getPersonaPrueba(): any {
    return {
      id: 1,
      solicitudId: 1001,
      curp: 'GARC800101HDFRRN09',
      cvu: '123456',
      nivelSnii: 'Nivel I',
      nombre: 'Carlos',
      primerApellido: 'García',
      segundoApellido: 'Ramírez',
      fechaNacimiento: '1980-01-01',
      generoId: 'M',
      generoNombre: 'Masculino',
      nacionalidadId: 'MX',
      nacionalidadNombre: 'Mexicana',
      paisNacimientoId: 'MX',
      paisNacimientoNombre: 'México',
      activated: true,
    };
  }

  public static getPersonas(): any[] {
    return [
      {
        id: 1,
        solicitudId: 1001,
        curp: 'GARC800101HDFRRN09',
        cvu: '123456',
        nivelSnii: 'Nivel I',
        nombre: 'Carlos',
        primerApellido: 'García',
        segundoApellido: 'Ramírez',
        fechaNacimiento: '1980-01-01',
        generoId: 'M',
        generoNombre: 'Masculino',
        nacionalidadId: 'MX',
        nacionalidadNombre: 'Mexicana',
        paisNacimientoId: 'MX',
        paisNacimientoNombre: 'México',
        activated: true,
      },
      {
        id: 2,
        solicitudId: 1002,
        curp: 'LOPR850505MDFRRL02',
        cvu: '654321',
        nivelSnii: 'Candidato',
        nombre: 'María',
        primerApellido: 'López',
        segundoApellido: 'Rodríguez',
        fechaNacimiento: '1985-05-05',
        generoId: 'F',
        generoNombre: 'Femenino',
        nacionalidadId: 'MX',
        nacionalidadNombre: 'Mexicana',
        paisNacimientoId: 'MX',
        paisNacimientoNombre: 'México',
        activated: false,
      },
    ];
  }
}
